
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWallPte from '../components/Frontend/FameWallPte';
import Testimonial from '../components/Frontend/Testimonial';
import TestimonialVid from '../components/Frontend/VideoPTETestimonial';
import SimpleReactValidator from 'simple-react-validator';
import { store } from 'store/index';
import { setAlert } from 'action/index.js';
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Plans from "page/plans";
import { getCountryForTimezone } from 'countries-and-timezones';

class Pte extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            course: 'PTE On-Campus',
            lang: 'Hindi',
            query: '',
            flag: false,
            loginLock: false,
            readMoreFlag: false,
            plans: []
        };
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('2474090032742391');
        ReactPixel.init('197333187452630');
        ReactPixel.pageView();
        this.getPackages();
    }

    getPackages() {
        const country = getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        let countryId = "AU";
        if (country && country.id) {
            countryId = country.id;
        }
        const url = process.env.REACT_APP_URL_ALT + '/api/v2/getPackages?countryId=' + countryId;
        API({
            url: url,
            method: "GET",
        }).then((res) => {
            if (res.status === 200) {
                const { data } = res.data;
                this.setState({ plans: data });
            } else {
                store.dispatch(setAlert({ 'flag': true, 'type': 2, 'message': "Something went wrong." }));
            }
        })
    }

    submitForm = (e) => {
        e.preventDefault();
        this.hitApi();
    }

    hitApi = async () => {
        if (this.state.loginLock) {
            return;
        }
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        this.setState({ loginLock: true });

        var bodyFormData = new FormData();
        bodyFormData.set('email', this.state.email);
        bodyFormData.set('name', this.state.name);
        bodyFormData.set('phone', this.state.phone);
        bodyFormData.set('message', 'Lang: ' + this.state.lang + '<br/>course: ' + this.state.course + '<br/>Query: ' + this.state.query);
        bodyFormData.set('data', 'email: ' + this.state.email + ',name: ' + this.state.name + ',phone: ' + this.state.phone + ',lang: ' + this.state.lang + ',course: ' + this.state.course + ',query: ' + this.state.query);
        bodyFormData.set('page', "PTE coaching New South Wales");
        let res = null;
        try {
            res = await API({
                method: 'POST',
                url: 'sendOnlinePte',
                data: bodyFormData
            })
        } catch (error) {

        };
        console.log(res)
        if (res?.status === 200) {
            store.dispatch(setAlert({ 'flag': true, 'type': 1, 'message': res.data.message }));
            this.setState({ name: '', email: '', phone: '', course: 'PTE On-Campus', query: '', loginLock: false, flag: true })
        } else {
            this.setState({ loginLock: false });
        }
    }

    changeReadMore = () => {
        this.setState({ readMoreFlag: !this.state.readMoreFlag })
    }

    changeInput = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value });
    }

    render() {
        if (this.state.flag) {
            return (<Redirect to="/thank-you" />);
        }

        const sliderSettings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <Helmet>
                    <title>PTE Coaching Classes in NSW – Master English Proficiency with Expert Guidance | Language Academy</title>
                    <meta name="twitter:title" content="PTE Coaching Classes in NSW – Master English Proficiency with Expert Guidance" />
                    <meta property="og:title" content="PTE Coaching Classes in NSW – Master English Proficiency with Expert Guidance" />
                    <meta name="description" content="Professional PTE Academic Coaching Across New South Wales – Online & Classroom Training in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong & Regional NSW" />
                    <meta name="twitter:description" content="Professional PTE Academic Coaching Across New South Wales – Online & Classroom Training in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong & Regional NSW" />
                    <meta property="og:description" content="Professional PTE Academic Coaching Across New South Wales – Online & Classroom Training in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong & Regional NSW" />
                </Helmet>
                <Header />
                <div className="innerPage">
                    {/* Hero Section */}
                    <section className="bannerOuter">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 text-center mt-4">
                                    <h1>PTE Coaching Classes in NSW – Master English Proficiency with Expert Guidance</h1>
                                    <span>Professional PTE Academic Coaching Across New South Wales – Online & Classroom Training in Sydney, Parramatta, Liverpool, Blacktown, Penrith, Newcastle, Wollongong & Regional NSW</span><br />
                                    <div className="mt-4">
                                        <Link to="/contact" className="themeBtn mr-3">Book Your Free PTE Assessment & Demo Class</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Transform Your Future Section */}
                    <section className="transformFuture py-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h2 className="title text-center">Transform Your Future with Premier <span>PTE Coaching Classes in NSW</span></h2>
                                    <p className="text-center">Ready to achieve your dream PTE score? Our specialized PTE preparation NSW programs deliver exceptional results for students across New South Wales. From bustling Sydney to scenic Newcastle and growing Wollongong, we provide comprehensive PTE Academic coaching in NSW designed to maximize your success.</p>

                                    <div className="row mt-5">
                                        <div className="col-md-6">
                                            <h4>Why Thousands Choose Our PTE Training:</h4>
                                            <ul className="checklist">
                                                <li>85% of students achieve their target score on the first attempt</li>
                                                <li>Expert trainers with proven track records</li>
                                                <li>Flexible learning options – classroom and online formats</li>
                                                <li>Comprehensive study materials and unlimited practice tests</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="trust-elements">
                                                <div className="row text-center">
                                                    <div className="col-6 mb-3">
                                                        <strong style={{ fontSize: '2rem', color: '#007bff' }}>10K+</strong><br />
                                                        <span>Students Taught</span>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <strong style={{ fontSize: '2rem', color: '#007bff' }}>85%</strong><br />
                                                        <span>First Attempt Success</span>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <strong style={{ fontSize: '2rem', color: '#007bff' }}>8+</strong><br />
                                                        <span>Years Experience</span>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <strong style={{ fontSize: '2rem', color: '#007bff' }}>4.8★</strong><br />
                                                        <span>Google Rating</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/contact" className="themeBtn">Get Your Free PTE Score Assessment Now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Understanding PTE Academic Section */}
                    <section className="whatispte">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h2 className="title">Understanding PTE Academic: <span>Your Path to Australian Success</span></h2>
                                    <p>PTE Academic (Pearson Test of English Academic) is Australia's leading computer-based English proficiency test, essential for visa applications, university admissions, and professional registration.</p>

                                    <div className="row mt-4">
                                        <div className="col-md-6">
                                            <h4>Why PTE Academic Matters in NSW:</h4>
                                            <ul className="checklist">
                                                <li>Fastest results – scores available within 48 hours</li>
                                                <li>Accepted by all Australian universities, including top Sydney institutions</li>
                                                <li>Required for skilled migration</li>
                                                <li>Fair computer scoring eliminates human bias</li>
                                                <li>Flexible test dates with frequent availability across NSW</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <h4>Test Format Overview:</h4>
                                            <ul className="checklist">
                                                <li><strong>Speaking & Writing:</strong> 54-67 minutes</li>
                                                <li><strong>Reading:</strong> 29-30 minutes</li>
                                                <li><strong>Listening:</strong> 30-43 minutes</li>
                                                <li><strong>Total duration:</strong> Approximately 2 hours</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/auth/register" className="themeBtn">Enroll in Our PTE Coaching Program Today</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Why We're Recognized Section */}
                    <section className="whyRecognized py-5 bg-light">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h2 className="title text-center">Why We're Recognized as the <span>Best PTE Institute in NSW</span></h2>
                                    <p className="text-center">Our commitment to excellence has established us as the best PTE institute in NSW, delivering outstanding results through:</p>

                                    <div className="row mt-5">
                                        <div className="col-md-6 col-lg-3 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-body text-center">
                                                    <img src="images/star-ribben.png" alt="proven-track-record" width="60" height="60" className="mb-3" />
                                                    <h4 className="card-title">Proven Track Record</h4>
                                                    <ul className="list-unstyled text-left">
                                                        <li>✓ 10,000+ successful students across NSW</li>
                                                        <li>✓ Average score improvement of 20+ points</li>
                                                        <li>✓ Specialized coaching for scores 50+, 60+, and 75+</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-3 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-body text-center">
                                                    <img src="images/experienced-trainer.png" alt="expert-faculty" width="60" height="60" className="mb-3" />
                                                    <h4 className="card-title">Expert Faculty Team</h4>
                                                    <ul className="list-unstyled text-left">
                                                        <li>✓ Certified PTE trainers with advanced qualifications</li>
                                                        <li>✓ Regular training updates on latest PTE patterns</li>
                                                        <li>✓ Personal mentorship for each student's unique needs</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-3 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-body text-center">
                                                    <img src="images/support.png" alt="strategic-locations" width="60" height="60" className="mb-3" />
                                                    <h4 className="card-title">Strategic Locations</h4>
                                                    <ul className="list-unstyled text-left">
                                                        <li>✓ Physical center in Parramatta</li>
                                                        <li>✓ Live online classes serving the whole world</li>
                                                        <li>✓ State-of-the-art facilities with latest technology</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-3 mb-4">
                                            <div className="card h-100 border-0 shadow-sm">
                                                <div className="card-body text-center">
                                                    <img src="images/book.png" alt="comprehensive-resources" width="60" height="60" className="mb-3" />
                                                    <h4 className="card-title">Comprehensive Resources</h4>
                                                    <ul className="list-unstyled text-left">
                                                        <li>✓ Updated curriculum aligned with current PTE format</li>
                                                        <li>✓ AI-powered practice platforms for realistic preparation</li>
                                                        <li>✓ Extensive question banks with detailed explanations</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <a href="tel:+61426230061" className="themeBtn">Call Now: +61 426 230 061 for PTE Coaching in NSW</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Comprehensive PTE Course Features */}
                    <section className="courseFeatures py-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h2 className="title text-center">Comprehensive PTE Course Features: <span>Everything You Need to Succeed</span></h2>

                                    <div className="row mt-5">
                                        <div className="col-md-6 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body">
                                                    <h4 className="card-title">
                                                        <img src="images/book.png" alt="study-materials" width="40" height="40" className="mr-2" />
                                                        Premium Study Materials
                                                    </h4>
                                                    <ul className="list-unstyled">
                                                        <li>✓ Latest PTE templates for all question types</li>
                                                        <li>✓ Comprehensive web portal with 1000+ practice questions</li>
                                                        <li>✓ Video lessons library covering advanced techniques</li>
                                                        <li>✓ Mobile app access for on-the-go learning</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body">
                                                    <h4 className="card-title">
                                                        <img src="images/settings.png" alt="mock-tests" width="40" height="40" className="mr-2" />
                                                        Realistic Mock Tests & Assessment
                                                    </h4>
                                                    <ul className="list-unstyled">
                                                        <li>✓ Computer-delivered practice tests mimicking actual PTE</li>
                                                        <li>✓ Detailed score reports with section-wise analysis</li>
                                                        <li>✓ AI-powered feedback for continuous improvement</li>
                                                        <li>✓ Weekly progress tracking with personalized recommendations</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body">
                                                    <h4 className="card-title">
                                                        <img src="images/experienced-trainer.png" alt="training-team" width="40" height="40" className="mr-2" />
                                                        World-Class Training Team
                                                    </h4>
                                                    <ul className="list-unstyled">
                                                        <li>✓ Native English speakers with PTE expertise</li>
                                                        <li>✓ Individual attention in small batch sizes</li>
                                                        <li>✓ Regular doubt-clearing sessions</li>
                                                        <li>✓ Success coaching beyond language skills</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body">
                                                    <h4 className="card-title">
                                                        <img src="images/support.png" alt="flexible-learning" width="40" height="40" className="mr-2" />
                                                        Flexible Learning Options
                                                    </h4>
                                                    <p><strong>Online PTE Coaching NSW:</strong></p>
                                                    <ul className="list-unstyled">
                                                        <li>✓ Live interactive sessions via advanced platforms</li>
                                                        <li>✓ Recorded class access for revision</li>
                                                        <li>✓ Virtual one-on-one mentoring</li>
                                                        <li>✓ 24/7 technical support</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/free-mock-test" className="themeBtn">Book a Free PTE Demo Class – Experience Our Teaching Excellence</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Strategic Score Targets */}
                    <section className="scoreTargets py-5 bg-light">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h2 className="title text-center">Strategic Score Targets: <span>Customized Pathways for Every Goal</span></h2>

                                    <div className="row mt-5">
                                        <div className="col-md-4 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body text-center">
                                                    <div className="mb-3">
                                                        <span style={{ fontSize: '3rem', fontWeight: 'bold', color: '#28a745' }}>55+</span>
                                                    </div>
                                                    <h4 className="card-title">Foundation Level</h4>
                                                    <p className="text-muted">Success rate: 88%</p>
                                                    <ul className="list-unstyled text-left">
                                                        <li>• Standard requirement for most applications</li>
                                                        <li>• Focus: Fluency development, template mastery</li>
                                                        <li>• Ideal for: Most university courses, standard skilled migration</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body text-center">
                                                    <div className="mb-3">
                                                        <span style={{ fontSize: '3rem', fontWeight: 'bold', color: '#007bff' }}>65+</span>
                                                    </div>
                                                    <h4 className="card-title">Competent Level</h4>
                                                    <p className="text-muted">Success rate: 76%</p>
                                                    <ul className="list-unstyled text-left">
                                                        <li>• Premium scores for competitive advantage</li>
                                                        <li>• Focus: Advanced techniques, perfection strategies</li>
                                                        <li>• Ideal for: Top universities, maximum migration points</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-4">
                                            <div className="card h-100 border-0 shadow">
                                                <div className="card-body text-center">
                                                    <div className="mb-3">
                                                        <span style={{ fontSize: '3rem', fontWeight: 'bold', color: '#ffc107' }}>75+</span>
                                                    </div>
                                                    <h4 className="card-title">Proficient Level</h4>
                                                    <p className="text-muted">Success rate: 65%</p>
                                                    <ul className="list-unstyled text-left">
                                                        <li>• Exceptional performance for elite opportunities</li>
                                                        <li>• Focus: Native-level fluency, academic excellence</li>
                                                        <li>• Ideal for: Scholarship applications, premium institutions</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/contact" className="themeBtn">Get Personalized Score Strategy – Free Consultation</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Tutorial Video Section */}

                    {/* Success Stories Section */}
                    <section className="tutorialVd m-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h2 className="title">Success Stories: <span>Real Results from NSW Students</span></h2>
                                    <div className="videosCntnt">
                                        <Slider {...{
                                            dots: false,
                                            arrows: false,
                                            infinite: true,
                                            slidesToShow: 3,
                                            slidesToScroll: 1,
                                            responsive: [
                                                {
                                                    breakpoint: 767,
                                                    settings: {
                                                        slidesToShow: 2,
                                                        infinite: true,
                                                        slidesToScroll: 1,
                                                    },
                                                },
                                                {
                                                    breakpoint: 480,
                                                    settings: {
                                                        infinite: true,
                                                        slidesToShow: 1,
                                                        slidesToScroll: 1,
                                                    },
                                                },
                                            ],
                                        }} className="testiContent regular02 slider" style={{maxWidth: 'none'}}>
                                            <div className="videoBlk" style={{width: '100%'}}>
                                                <div className="review__vid" style={{width: '100%', minHeight: '150px'}}>
                                                    <p>"Jumped from 58 to 79 in just 6 weeks! The personalized feedback was incredible."</p>
                                                    <div className="align-items-center d-flex">
                                                        <i className="fa fa-user-circle border user-rev__thumb"></i>
                                                        <span className="ms-2">
                                                            <b>- Sarah M. - Liverpool</b>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="videoBlk" style={{width: '100%'}}>
                                                <div className="review__vid" style={{width: '100%', minHeight: '150px'}}>
                                                    <p>"Online classes were perfect for my schedule. Achieved 65+ and got my visa approved!"</p>
                                                    <div className="align-items-center d-flex">
                                                        <i className="fa fa-user-circle border user-rev__thumb"></i>
                                                        <span className="ms-2">
                                                            <b>- Raj P. - Newcastle</b>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="videoBlk" style={{width: '100%'}}>
                                                <div className="review__vid" style={{width: '100%', minHeight: '150px'}}>
                                                    <p>"Failed PTE twice before finding this institute. Finally got 72 overall!"</p>
                                                    <div className="align-items-center d-flex">
                                                        <i className="fa fa-user-circle border user-rev__thumb"></i>
                                                        <span className="ms-2">
                                                            <b>- Chen L. - Parramatta</b>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="videoBlk" style={{width: '100%'}}>
                                                <div className="review__vid" style={{width: '100%', minHeight: '150px'}}>
                                                    <p>"Best investment ever. From 45 to 68 in two months. University admission secured!"</p>
                                                    <div className="align-items-center d-flex">
                                                        <i className="fa fa-user-circle border user-rev__thumb"></i>
                                                        <span className="ms-2">
                                                            <b>- Maria S. - Wollongong</b>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link to="/auth/register" className="themeBtn">Join Our Success Community – Limited Seats Available</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* FAQ Section */}
                    <section className="faq py-40" id="faq">
                        <div className="container">
                            <div className="row">
                                <div className="col la-free-mt-app-title-col">
                                    <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                                        <h2>Frequently Asked <span>Questions: PTE Coaching in NSW</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="col-10 mx-auto">
                                        <div className="accordion" id="faqAccordion">
                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingOne">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                            How long does PTE preparation take?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        Preparation time varies by current English level and target score. Most students achieve their goals within 4-12 weeks with consistent practice and expert guidance.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingTwo">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                            What's included in your PTE coaching classes in NSW?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        Complete packages include expert instruction, comprehensive materials, unlimited mock tests, personal feedback, and online resources.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingThree">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                            How effective is online PTE coaching compared to classroom learning?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        Our online PTE Academic coaching delivers an identical curriculum and results. 82% of online students achieve target scores, with added flexibility for busy schedules.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingFour">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                            What makes your institute the best PTE coaching in NSW?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        Our combination of expert trainers, proven methodologies, comprehensive resources, flexible learning options, and outstanding success rates sets us apart.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingFive">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                            Do you provide study materials for PTE preparation in NSW?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        Yes, all students receive premium study materials, including online resources, a mobile app, and access to extensive question banks.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="customCard">
                                                <div className="custom-card-header" id="headingSix">
                                                    <h5 className="mb-0">
                                                        <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                                            How much do your PTE coaching classes in NSW cost?
                                                        </button>
                                                    </h5>
                                                </div>
                                                <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#faqAccordion">
                                                    <div className="card-body px-0 py-3">
                                                        We offer customized programs for both online and offline formats to match your specific needs and goals. Contact us for detailed information about our current packages and special offers.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-center mt-5">
                                            <a href="https://wa.me/61426230061" target="_blank" rel="noopener noreferrer" className="themeBtn">WhatsApp Us: +61 426 230 061 for Instant Answers</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Contact CTA Section */}
                    <section className="contactCTA py-5 bg-primary text-white">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h2 className="mb-4">Get Your Customized Program Quote Today</h2>
                                    <p className="lead mb-4">Every student's journey is unique. Let us design the perfect PTE preparation program for your specific needs and budget.</p>

                                    <div className="row mt-5">
                                        <div className="col-md-3 mb-3">
                                            <h5>Phone/WhatsApp</h5>
                                            <p><a href="tel:+61426230061" className="text-white">+61 426 230 061</a></p>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <h5>Email</h5>
                                            <p><a href="mailto:info@languageacademy.com.au" className="text-white">info@languageacademy.com.au</a></p>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <h5>Consultation Hours</h5>
                                            <p>Mon-Thu: 9:00 AM - 5:00 PM<br />Sat: 9:00 AM - 5:00 PM</p>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <h5>Walk-in</h5>
                                            <p>Visit any of our NSW centers</p>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <Link to="/contact" className="themeBtn btn-light mr-3">Schedule Your Free Consultation</Link>
                                        <a href="https://wa.me/61426230061" target="_blank" rel="noopener noreferrer" className="themeBtn btn-light">WhatsApp Us Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

      

                    <Footer />
                </div>
            </React.Fragment>
        );
    }
}

export default Pte;